var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 11.8125C7.25 11.6633 7.30926 11.5202 7.41475 11.4148C7.52024 11.3093 7.66332 11.25 7.8125 11.25H11.1875C11.3367 11.25 11.4798 11.3093 11.5852 11.4148C11.6907 11.5202 11.75 11.6633 11.75 11.8125C11.75 11.9617 11.6907 12.1048 11.5852 12.2102C11.4798 12.3157 11.3367 12.375 11.1875 12.375H7.8125C7.66332 12.375 7.52024 12.3157 7.41475 12.2102C7.30926 12.1048 7.25 11.9617 7.25 11.8125ZM5 8.4375C5 8.28832 5.05926 8.14524 5.16475 8.03975C5.27024 7.93426 5.41332 7.875 5.5625 7.875H13.4375C13.5867 7.875 13.7298 7.93426 13.8352 8.03975C13.9407 8.14524 14 8.28832 14 8.4375C14 8.58668 13.9407 8.72976 13.8352 8.83525C13.7298 8.94074 13.5867 9 13.4375 9H5.5625C5.41332 9 5.27024 8.94074 5.16475 8.83525C5.05926 8.72976 5 8.58668 5 8.4375ZM2.75 5.0625C2.75 4.91332 2.80926 4.77024 2.91475 4.66475C3.02024 4.55926 3.16332 4.5 3.3125 4.5H15.6875C15.8367 4.5 15.9798 4.55926 16.0852 4.66475C16.1907 4.77024 16.25 4.91332 16.25 5.0625C16.25 5.21168 16.1907 5.35476 16.0852 5.46025C15.9798 5.56574 15.8367 5.625 15.6875 5.625H3.3125C3.16332 5.625 3.02024 5.56574 2.91475 5.46025C2.80926 5.35476 2.75 5.21168 2.75 5.0625Z",
    fill: "#0D8ECA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilters);
export default __webpack_public_path__ + "static/media/filters.6c4ca9725d1c0208c09eb2201618f255.svg";
export { ForwardRef as ReactComponent };